import { lazy } from 'react';

const EvTariffInformationContent = import(
  'components/direct-sales/ev-tariff-information-revamp/components/EvTariffInformationContent'
);
const EvTariffInformationSidebarRight = import(
  'components/direct-sales/ev-tariff-information-revamp/components/EvTariffInformationSidebarRight'
);
const EvTariffInformationHeader = import(
  'components/direct-sales/ev-tariff-information-revamp/components/EvTariffInformationHeader'
);
const EvTariffInformationFooter = import(
  'components/direct-sales/ev-tariff-information-revamp/components/EvTariffInformationFooter'
);

export const EvTariffInformation = {
  Content: lazy(() => EvTariffInformationContent),
  RightSidebar: lazy(() => EvTariffInformationSidebarRight),
  Header: lazy(() => EvTariffInformationHeader),
  Footer: lazy(() => EvTariffInformationFooter)
};

export default EvTariffInformation;
